'use client'

import { useRouterContext } from '~/lib/next/use-router-context'

import type { ReactNode } from 'react'
import { useEffect, useRef, useState } from 'react'

function AppRouteLoading({ children }: { children: ReactNode }) {
  const [loading, setLoading] = useState(false)
  const { pathname, searchParams } = useRouterContext()
  const prevPathnameRef = useRef<string | null>(null)
  const prevSearchParamsRef = useRef<string | null>(null)
  const loadingTimeoutRef = useRef<NodeJS.Timeout | null>(null)

  useEffect(() => {
    const currentPathname = pathname
    const currentSearchParams = searchParams?.toString() || ''

    // Check if route has changed
    const hasRouteChanged =
      prevPathnameRef.current !== null &&
      (prevPathnameRef.current !== currentPathname ||
        prevSearchParamsRef.current !== currentSearchParams)

    if (hasRouteChanged) {
      // Route change start
      setLoading(true)

      // Clear any existing timeout
      if (loadingTimeoutRef.current) {
        clearTimeout(loadingTimeoutRef.current)
      }

      // Route change complete after a short delay
      // This simulates the routeChangeComplete event
      loadingTimeoutRef.current = setTimeout(() => {
        setLoading(false)
      }, 100)
    }

    // Update refs for next comparison
    prevPathnameRef.current = currentPathname
    prevSearchParamsRef.current = currentSearchParams

    return () => {
      if (loadingTimeoutRef.current) {
        clearTimeout(loadingTimeoutRef.current)
      }
    }
  }, [pathname, searchParams])

  return (
    <div className="relative">
      {loading ? (
        <div className="fixed top-0 right-0 bottom-0 left-0 z-1234567890 flex items-center justify-center bg-gray-50/5" />
      ) : null}
      {children}
    </div>
  )
}

export default AppRouteLoading
